import prompts from "prompts";

export interface InitAnswers {
  publicDir: string;
  usePWA: boolean;
  includeConfig: boolean;
  offlinePagePath: string;
  swPath: string;
  appName: string;
  themeColor: string;
  debug: boolean;
}

export async function askInitQuestions(): Promise<InitAnswers> {
  const response = await prompts(
    [
      {
        type: "text",
        name: "publicDir",
        message: "Where should generated public files go?",
        initial: "public"
      },
      {
        type: "confirm",
        name: "usePWA",
        message: "Generate a web app manifest too?",
        initial: true
      },
      {
        type: "confirm",
        name: "includeConfig",
        message: "Generate a go-offline config file?",
        initial: true
      },
      {
        type: "text",
        name: "offlinePagePath",
        message: "Offline page URL path",
        initial: "/offline.html"
      },
      {
        type: "text",
        name: "swPath",
        message: "Service worker URL path",
        initial: "/sw.js"
      },
      {
        type: (prev: boolean) => (prev ? "text" : null),
        name: "appName",
        message: "PWA app name",
        initial: "Go Offline App"
      },
      {
        type: (prev: string, values: Record<string, unknown>) =>
          values.usePWA ? "text" : null,
        name: "themeColor",
        message: "Theme color",
        initial: "#0f172a"
      },
      {
        type: "confirm",
        name: "debug",
        message: "Enable debug logs in the starter config?",
        initial: false
      }
    ],
    {
      onCancel: () => {
        throw new Error("Setup cancelled.");
      }
    }
  );

  return response as InitAnswers;
}
